// ServiceAreas.jsx
import React from "react";
import { Link } from "react-router-dom";

// Define towns and their URL slugs
const towns = [
  { name: "Monroe, NJ", slug: "monroe-nj" },
  { name: "East Windsor, NJ", slug: "east-windsor-nj" },
  { name: "Plainsboro, NJ", slug: "plainsboro-nj" },
  { name: "West Windsor, NJ", slug: "west-windsor-nj" },
  { name: "Princeton Junction, NJ", slug: "princeton-junction-nj" },
  { name: "Dayton, NJ", slug: "dayton-nj" },
  { name: "Robbinsville, NJ", slug: "robbinsville-nj" },
  { name: "Cranbury, NJ", slug: "cranbury-nj" },
];

const ServiceAreas = () => {
  return (
    <section className="bg-green-50 py-12 px-6 text-center mt-20">
      <h2 className="text-2xl font-semibold text-green-800 mb-4">
        Proudly Serving Central New Jersey
      </h2>
      <p className="text-gray-700 max-w-2xl mx-auto mb-6">
        LawnSmartPro provides lawn care, landscaping, and irrigation services in
        the following communities:
      </p>
      <ul className="flex flex-wrap justify-center gap-4 text-green-700 font-medium text-sm">
        {towns.map(({ name, slug }) => (
          <li key={slug}>
            <Link to={`/lawn-care-${slug}`} className="hover:underline">
              {name}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ServiceAreas;
